import styles from "./searchfilterbar.module.css";
import { Col, Row } from "react-bootstrap";
import Input from "../V2/Widgets/Input";
import Button from "../Button";

function SearchFilterBar({
  inputText,
  handleInputChange,
  showFilter,
  setShowFilter,
  placeholder = "Search...",
  setInputText,
  onFilterClose,
}) {
  const handleAdvanceSearch = () => {
    setInputText("");
    setShowFilter(true);
  };
  const handleBack = () => {
    setShowFilter(false);
    setInputText(""); 
    if (onFilterClose) onFilterClose();
  };
  return (
    <Row>
      {!showFilter ? (
        <>
          <Col md={7}>
            <Input
              placeholder={placeholder}
              value={inputText}
              onChange={handleInputChange}
            />
          </Col>
          <Col md={2} className={styles.searchButton}>
            <Button title="Advance Search" onClick={handleAdvanceSearch} />
          </Col>
        </>
      ) : (
        <Col md={2} className={styles.searchButton}>
          <Button title="Back" onClick={handleBack} />
        </Col>
      )}
    </Row>
  );
}

export default SearchFilterBar;
